<!-- Use same component for generic error message, maybe add a new property to the toast object -->
<div
  class="toast-container"
  [class.success]="toast.type === 'success'"
  [class.error]="toast.type.includes('error')"
>
  <ion-icon
    name="alert-circle-outline"
    data-cy="toast-container-icon"
  ></ion-icon>
  <span class="message" data-cy="toast-messsage-text">
    <ng-container *ngIf="toast.type === 'nodataerror'; else apiError">
      No data available for download in the
      <span class="report-name">{{ toast.report }}</span
      >. Please adjust your
      <span class="filter-link" (click)="filterClick()">filters</span>.
    </ng-container>
    <ng-template #apiError>
      <ng-container *ngIf="toast.type === 'apierror'; else genericError">
        Oops! Something went wrong with report
        <span class="report-name">{{ toast.report }}</span
        >. Error Code: {{ toast.errorCode }}. Please try again, if the issue
        persists, contact IT at
        <a class="filter-link" href="tel:+18886482580" (click)="onClose()"
          >+1-888-648-2580</a
        >
      </ng-container>
    </ng-template>
    <ng-template #genericError>
      <div *ngIf="toast.type === 'error'" [innerHTML]="toast.report"></div>
    </ng-template>
  </span>

  <ion-icon
    *ngIf="toast.dismissible"
    name="close-circle"
    class="btn-dismiss"
    data-cy="dismiss-button-icon"
    (click)="onClose()"
  ></ion-icon>
</div>
